import { filterDomainIds } from 'app/area/filters/constants';
import { FavouriteDefinition } from 'app/types-shared';

export const getCaseTypeIds = (definition: FavouriteDefinition): number[] => {
  const caseTypeCondition = definition?.conditions && definition.conditions
    .find(c => c.domain.v === filterDomainIds.caseType);
  if (caseTypeCondition && !!caseTypeCondition.values) {
    return caseTypeCondition.values.map(v => v.code && v.code.v);
  }
  return [];
};
